import RestResourceService from "@/services/RestResourceService";
import errorParser from "../../utils/errorParser";

function initialState() {
    return {
        data: ''
    }
}

export default {
    state: initialState(),
    getters: {
        QUEUE_UP_DISPLAY_DATA: state => {
            return state.data
        },
    },
    mutations: {
        SET_QUEUE_UP_DISPLAY_DATA(state, payload) {
            state.data = payload;
        },
        RESET(state) {
            const s = initialState();
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        },
    },
    actions: {
        GET_QUEUE_UP_DISPLAY_DATA: async ({commit}, payload) => {
            return RestResourceService.getResources(`/api/v1/queue-up/${payload.tenantCode}/${payload.code}/display`)
                .then((response) => {
                    commit('SET_QUEUE_UP_DISPLAY_DATA', response.data);
                })
                .catch((error) => {
                    errorParser.parse(error);
                    throw new Error(error);
                })
        },
        RESET: (context, payload) => {
            context.commit('RESET', payload);
        },
    }
}
